import { api } from "@/redux/api";

import {
	FeatureOnboardingResponse,
	FeatureOnboardingResponseSchema,
	DismissStepResponse,
	DismissStepResponseSchema,
	DismissAllResponse,
	DismissAllResponseSchema,
} from "../../pages/FeatureOnboarding/schema/featureOnboarding";

export const featureOnboardingApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getPendingOnboarding: builder.query<FeatureOnboardingResponse, void>({
			query: () => ({
				url: "feature-onboarding",
				responseSchema: FeatureOnboardingResponseSchema,
			}),
			providesTags: ["FeatureOnboarding"],
		}),
		dismissStep: builder.mutation<DismissStepResponse, number>({
			query: (id) => ({
				url: `feature-onboarding/${id}/dismiss`,
				method: "PATCH",
				responseSchema: DismissStepResponseSchema,
			}),
			invalidatesTags: ["FeatureOnboarding"],
		}),
		dismissAll: builder.mutation<DismissAllResponse, string>({
			query: (featureCode) => ({
				url: `feature-onboarding/dismiss-all/${featureCode}`,
				method: "PATCH",
				responseSchema: DismissAllResponseSchema,
			}),
			invalidatesTags: ["FeatureOnboarding"],
		}),
	}),
});

export const { useGetPendingOnboardingQuery, useDismissStepMutation, useDismissAllMutation } =
	featureOnboardingApi;
